export const textPositionOptions = [
    { label: 'Izquierda', value: 'text-start' },
    { label: 'Centro', value: 'text-center' },
    { label: 'Derecha', value: 'text-end text-right' }
];

export const clientTypeOptions = [
    { label: 'Empresariales', value: 'empresariales' },
    { label: 'Institucionales', value: 'institucionales' },
    { label: 'Personas Naturales', value: 'personas_naturales' }
];

export const clientTypeOptionsList = [
    { label: 'Empresarial', value: 'company' },
    { label: 'Personal', value: 'normal' },
    { label: 'Institucional', value: 'private' }
];

export const typeDetail = [
    { label: 'Sección de Iconografia', value: 'liton_tab_3_1' },
    { label: 'Detalles de Acabado', value: 'liton_tab_3_2' },
    { label: 'Mapa', value: 'liton_tab_3_3' }
];

export const typeFilter = [
    { label: 'Selección Unica', value: 'single' },
    { label: 'Selección Multiple', value: 'multiple' },
    { label: 'Selección de Rango', value: 'range' },
    { label: 'Excluyente', value: 'toggle' }
];

export const typeOptionProduct = [
    { label: 'Normal', value: 'normal' },
    { label: 'Estreno', value: 'new' },
];

export const formatDisplay = [
    { label: 'Imagen', value: 'image' },
    { label: 'Color', value: 'color' },
    { label: 'Texto', value: 'text' }
];

export const colorSelect = [
    { label: 'Blanco', value: 'Blanco', color: '#ffffff' },
    { label: 'Negro', value: 'Negro', color: '#000000' },
    { label: 'Gris', value: 'Gris', color: '#808080' },
    { label: 'Beige', value: 'Beige', color: '#f5f5dc' },
    { label: 'Marrón', value: 'Marrón', color: '#8b4513' },
    { label: 'Amarillo', value: 'Amarillo', color: '#ffff00' },
    { label: 'Naranja', value: 'Naranja', color: '#ffa500' },
    { label: 'Rosa', value: 'Rosa', color: '#ffc0cb' },
    { label: 'Púrpura', value: 'Púrpura', color: '#800080' },
    { label: 'Turquesa', value: 'Turquesa', color: '#40e0d0' },
    { label: 'Lima', value: 'Lima', color: '#00ff00' },
    { label: 'Oliva', value: 'Oliva', color: '#808000' },
    { label: 'Cian', value: 'Cian', color: '#00ffff' },
    { label: 'Magenta', value: 'Magenta', color: '#ff00ff' },
    { label: 'Dorado', value: 'Dorado', color: '#ffd700' },
    { label: 'Plateado', value: 'Plateado', color: '#c0c0c0' },
    { label: 'Bronce', value: 'Bronce', color: '#cd7f32' }
];